import { createFeature, createReducer, on } from "@ngrx/store";
import type { Part } from "@partikelart/parts/domain";
import { PartActions } from "./part.actions";

export interface PartState {
	parts: Part[];
	currentPart: Part | null;
	currentPartFormImagePath: string | null;
	loading: boolean;
	error: string | null;
}

export const initialState: PartState = {
	parts: [],
	currentPart: null,
	currentPartFormImagePath: null,
	loading: false,
	error: null,
};

export const partFeature = createFeature({
	name: "part",
	reducer: createReducer(
		initialState,
		on(
			PartActions.loadParts,
			PartActions.loadPartById,
			PartActions.loadPartByNumber,
			PartActions.createPart,
			PartActions.updatePart,
			PartActions.deletePart,
			(state) => ({ ...state, loading: true, error: null }),
		),

		on(PartActions.loadPartsSuccess, (state, { parts }) => ({
			...state,
			parts,
			loading: false,
		})),
		on(PartActions.loadPartByIdSuccess, PartActions.loadPartByNumberSuccess, (state, { part }) => ({
			...state,
			currentPart: part,
			loading: false,
		})),
		on(PartActions.setCurrentPart, (state, { part }) => ({
			...state,
			currentPart: part,
		})),
		on(PartActions.clearCurrentPart, (state) => ({
			...state,
			currentPart: null,
			currentPartFormImagePath: null,
			error: null,
		})),
		on(PartActions.createPartSuccess, (state, { part }) => ({
			...state,
			parts: [...state.parts, part],
			currentPart: part,
			currentPartFormImagePath: null,
			loading: false,
		})),
		on(PartActions.updatePartSuccess, (state, { part }) => ({
			...state,
			parts: state.parts.map((p) => (p.id === part.id ? part : p)),
			currentPart: state.currentPart?.id === part.id ? part : state.currentPart,
			loading: false,
		})),
		on(PartActions.deletePartSuccess, (state, { id }) => ({
			...state,
			parts: state.parts.filter((p) => p.id !== id),
			currentPart: state.currentPart?.id === id ? null : state.currentPart,
			loading: false,
		})),

		on(PartActions.setCurrentPartFormImagePath, (state, { path }) => ({
			...state,
			currentPartFormImagePath: path,
		})),

		on(
			PartActions.loadPartsFailure,
			PartActions.loadPartByIdFailure,
			PartActions.loadPartByNumberFailure,
			PartActions.createPartFailure,
			PartActions.updatePartFailure,
			PartActions.deletePartFailure,
			(state, { error }) => ({ ...state, error, loading: false }),
		),
	),
});
